export const normalizeHashRoute = (hash = '') => {
    if (!hash.startsWith('#/') || !hash.includes('%23')) {
        return hash;
    }

    const [routeWithAnchor, ...searchParts] = hash.split('?');
    const search = searchParts.length > 0 ? `?${searchParts.join('?')}` : '';

    return `${routeWithAnchor.replaceAll('%23', '#')}${search}`;
};

export const getNormalizedEncodedHashPath = (pathname = '') => {
    if (!pathname.includes('%23')) {
        return null;
    }

    const [routePathname, ...anchorParts] = pathname.split('%23');
    const anchor = anchorParts.join('%23');

    if (!routePathname || !anchor) {
        return null;
    }

    return {
        pathname: routePathname,
        hash: `#${anchor}`,
    };
};
